import React, { FC } from 'react';
import { Skeleton, Box, TableCell, TableCellProps } from '@dxb-web-ui-framework/design-system';

export interface SkeletonTableCellProps {
  hasSkeleton: boolean;
  tableCellProps?: TableCellProps;
}

const SkeletonTableCell: FC<SkeletonTableCellProps> = ({ hasSkeleton, tableCellProps, children }) => {
  if (hasSkeleton) {
    return (
      <TableCell {...tableCellProps}>
        <Skeleton variant='text' width={tableCellProps?.width || '100%'} height={tableCellProps?.height || '30px'}>
          <Box visibility='none'>{children}</Box>
        </Skeleton>
      </TableCell>
    );
  }

  return <TableCell {...tableCellProps}>{children}</TableCell>;
};

export { SkeletonTableCell };
